<label class="label d-flex flex-column">
  <div>
    {{ text }}
    <span
      requiredSymbol
      [isDisabled]="isDisabled"
      [isRequired]="isRequired"
      [hasRequiredValidator]="hasRequiredValidator"
    ></span>
  </div>
  <ng-content></ng-content>
</label>
